export default __webpack_public_path__ + "static/Punk-e825cee1aee95e38e2d3094f2fa04465.png";